
import PubSub from 'pubsub-js'
import { defineComponent, onMounted, ref, reactive } from 'vue'
import { PlayGround, InfoPanel } from './components/'
import GameControl from './GameControl'

export default defineComponent({
  name: 'App',
  components: {
    PlayGround,
    InfoPanel,
  },
  setup() {
    let gameControl: GameControl;
    const info = reactive({
      score: 0,
      level: 1,
    });
    const result = ref('');

    onMounted(() => {
      gameControl = new GameControl();
      console.log('gameControl', gameControl);

      // 订阅score.info的改变
      PubSub.subscribe('bus', (name, data) => {
        console.log('sub', name, data);
        const { score, level } = data;
        info.score = score;
        info.level = level;
      });

      PubSub.subscribe('result', (name, data) => {
        console.log('result', name, data);
        result.value = data;
      });
    });

    return {
      info,
      result,
    }
  }
})
